import { requireAuthOrTokenOrRedirectToGame } from '../guards.js';

export const path = '/glp-won/:gameId/pay';
export const component = 'GlpWonPay';
export const thunk =
  ({ ctx } = {}) =>
  (dispatch, getState) =>
    requireAuthOrTokenOrRedirectToGame(dispatch, getState, ctx);
